import Dialog from '@mui/material/Dialog';
import React from 'react';

import { CustomerPropertiesDto, CustomerTypeDto } from '@/api/generated';
import CustomersCreateBusinessView from '@/views/customers/createBusiness/CustomersCreateBusiness.view.tsx';
import CustomersCreateIndividualView from '@/views/customers/createIndividual/CustomersCreateIndividual.view.tsx';

type Props = {
  customerType: CustomerTypeDto;
  onClose: () => void;
  onCreated: (customerName: string) => void;
};

export const ProcessAddCustomerDialogCreateCustomerDialog: React.FC<Props> = props => {
  const { customerType, onClose, onCreated } = props;

  const handlePostCreateAction = (customer: CustomerPropertiesDto) => {
    onCreated(customer.name);
    onClose();
  };

  return (
    <Dialog open={true} sx={{ '& .MuiDialog-paper': { minWidth: '90vw' } }}>
      {customerType === CustomerTypeDto.Business ? (
        <CustomersCreateBusinessView
          onCancel={onClose}
          onPostCreateAction={handlePostCreateAction}
        />
      ) : (
        <CustomersCreateIndividualView
          onCancel={onClose}
          onPostCreateAction={handlePostCreateAction}
        />
      )}
    </Dialog>
  );
};
